<div class="container" *ngIf="!(loginInProgress$ | async); else loading">
  <app-catalog-table-header (tableHeaderLoaded)="catalogTableComponent.loadingCatalog()"></app-catalog-table-header>
  <div id="table-scroll-container" class="table-container" cdkScrollable>
    <app-catalog-table #catalogTableComponent></app-catalog-table>
  </div>

</div>

<ng-template #loading>
  <app-loader></app-loader>
</ng-template>
